import React, { Component } from "react";
import { getClientId } from "./utils/analyticsclientIdUtils";
import { encryptData } from "./utils/encryptionUtils";

export class ZPartner02 extends Component {
    static displayName = ZPartner02.name;

    constructor(props) {
        super(props);
        this.state = {
            
        };
    }

    componentDidMount() {
        const links = [
            "https://fonts.googleapis.com/css?family=Lato:300&text=1234567890,.-",
            "/css/style.css",
            "/css/style-sr.css"
        ];

        links.forEach(href => {
            const link = document.createElement("link");
            link.rel = "stylesheet";
            link.href = href;
            document.head.appendChild(link);
        });

        // Google Analytics / GTM tracking (same idea as EnAuthSignin)
        const documentPath = "Partner02_Index";
        const clientId = getClientId();

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "pageview",
            page: documentPath,
            clientId: clientId
        });

        // external app (LINE MAN WebView)
        // webviewAuthentication('{ "token":"...", "switchBackUrl":"...", "refUserId":"..." }')
        window.webviewAuthentication = async (jsonData) => {
            try {
                const data = JSON.parse(jsonData);

                const token = data.token;
                const switchBackUrl = data.switchBackUrl;
                const refUserId = data.refUserId;

                const timestamp = Math.floor(Date.now() / 1000);
                const payload = {
                    token: token,
                    switchBackUrl: switchBackUrl,
                    refUserId: refUserId,
                    partnerCode: "002",
                    Timestamp: timestamp
                };

                const encryptedPayload = encryptData(payload);

                const requestOptions = {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ Data: encryptedPayload, Timestamp: timestamp })
                };

                try {
                    const response = await fetch(`/api/ZPartnerLinkTokenVerify`, requestOptions);
                    const data = await response.json();

                    if (data.responseCode === "00") {
                        const refUserId = data.refUserId || "";
                        const switchBackUrl = data.switchBackUrl || "";

                        // success TokenVerify
                        window.location.href = `/X02LINEMAN/Home/?refUserId=${refUserId}&switchBackUrl=${switchBackUrl}`;
                    } else {
                        const message = data.responseMessage || "failed";
                        window.location.href = `/X02LINEMAN/Error/?S=${message}`;
                    }
                } catch (error) {
                    window.location.href = `/X02LINEMAN/Error/?S=${error}`;
                }
            } catch (error) {
                window.location.href = `/X02LINEMAN/Error/?S=1`;
            }
        };
    }

    componentWillUnmount() {
        delete window.webviewAuthentication;
    }    

    render() {        
        return (
            <>
                <div></div>
            </>

        );
    }
}
